/* istanbul ignore file */
import gql from "graphql-tag";

export default gql`
  extend type Query {
    listingsOfCache(ids: [ID!]!): [Listing]
    listingOfCache(id: ID!): Listing
  }
`;
